<template>
  <div
    class="mf-select"
    :class="{'mf-open': open, 'mf-open-down': !openUp, 'mf-open-up': openUp}"
    :tabindex="tabindex"
    @blur="open = false"
  >
      <label v-if="inputLabel" v-html="inputLabel"/>
    <i class="prz-chevron-down" @click="open = !open"></i>
    <div
      class="mf-select-selected"
      @click="open = !open"
      v-html="selectedText"
    ></div>
    <ul
      class="mf-select-items"
      :style="itemsCssStyles"
    >
      <li
        class="mf-select-item"
        :class="{selected: selected && option.value == selected.value }"
        v-for="(option, i) of options"
        :key="i"
        @click="selected=option; open=false; $emit('input', option.value)"
      >
        <span>{{ option.text }}</span>
        <i class="ecom-check" v-if="showCheckIcon && selected && option.value == selected.value"></i>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "SelectVue2",
  props:{
    options:{
      type: Array,
      required: true,
      default: null
    },
    tabindex:{
      type: Number,
      default: 0
    },
    label:{
      type: String,
      default: '&nbsp;'
    },
    openUp:{
      type: Boolean,
      default: false
    },
    maxDisplayOpen:{
      type: Number,
      default: 10
    },
    showCheckIcon:{
      type: Boolean,
      default: false
    },
    selectedDefault: {
        type: String,
        value: ''
    },
    inputLabel: {
        type: String,
        value: ''
    }
  },
  data() {
    return {
      selected: this.options && this.options.length === 1 ? this.options[0] : null,
      open: false,
      itemsCssStyles: {
        // 44px is the height of each option
        maxHeight: (this.maxDisplayOpen * 42) + 'px'
      },
    };
  },
  mounted(){
      if(this.selectedDefault) {
          this.selected = this.options.find(elm => elm.value == this.selectedDefault);
          if(!this.selected) {
              this.selected = this.options && this.options.length >= 1 ? this.options[0] : null;
          }
      }
      
    if(this.selected){
      this.$emit('input', this.selected.value);
    }
  },
  computed:{
    selectedText(){
      return this.selected ? this.selected.text : this.label;
    }
  }
};
</script>
